import styles from './MapControl.module.scss';
import { useContext, useEffect, useRef } from 'react';
import { MapContext } from 'os-elements';
import { Control } from 'ol/control';
import PropTypes from 'prop-types';

const MapControl = ({ children }) => {
    const { map } = useContext(MapContext);
    const ref = useRef();

    useEffect(() => {
        if (!map) {
            return;
        }
        const myControl = new Control({ element: ref.current });
        if (ref.current) {
            map.controls.push(myControl);
        }

        return () => map.controls.remove(myControl);
    }, [map, ref]);

    return <div ref={ref} className={styles.mapControl}>
        {children}
    </div>;
};

MapControl.propTypes = {
    children: PropTypes.any.isRequired,
    visible: PropTypes.bool
};

MapControl.defaultProps = {
    visible: true,
    testId: 'MapControl'
};

export default MapControl;
